$(document).ready(function () {
	// CATEGORIES - MOBILE
	// $('.JScategories .bi-list').on('click', function () { 
	// 	$('.JSlevel-1').slideToggle();
	// });

	$('.JSsubcat-toggle').on('click', function() {
		var $toggle = $(this);
		var $siblingItems = $toggle.parent().siblings();

		$toggle.toggleClass('rotate');
		$toggle.siblings('ul').slideToggle();
		$siblingItems.children('ul').slideUp();
		$siblingItems.find('.JSsubcat-toggle').removeClass('rotate');
	});

	/*======= MAIN CONTENT HEIGHT ========*/
	// var DESKTOP_BREAKPOINT = 1024;

	// $('.JScategories').on('mouseenter', function () {
	// 	if ($(window).width() <= DESKTOP_BREAKPOINT) return;

	// 	if ($('.d-content').height() < $('.JSlevel-1').height()) { 
	// 		$('.d-content').height($('.JSlevel-1').height());
	// 	}
	// }).on('mouseleave', function () {
	// 	if ($(window).width() <= DESKTOP_BREAKPOINT) return;

	// 	$('.d-content').height('');
	// });

	let JScategories = document.querySelector('.JScategories');
	let JSlevel1 = document.querySelector('.JSlevel-1');

	if (!JSlevel1 || !JScategories) return;

	JScategories.querySelector('.categories-header').addEventListener('click', () => {
		const isOpen = JSlevel1.getAttribute('aria-expanded') === 'true';
		const nextState = isOpen ? 'false' : 'true';
		JSlevel1.setAttribute('aria-expanded', nextState);
		document.body.classList.toggle('categories-menu-open', nextState === 'true');
	});

	document.addEventListener('click', e => {
		if (!JScategories.contains(e.target)) {
			JSlevel1.setAttribute('aria-expanded', 'false');
			document.body.classList.remove('categories-menu-open');
		}
	})
});
